/* System defined core library */
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { DynamicComponentService } from '../../../shared/services/dynamic.component.service';
import { RoutingService } from '../../../shared/services/routing.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { SelectedExamDetailService } from '../../shared/services/selected-exam-detail.service';

/* User defined models */
import { ContentResponse } from '../../../shared/models/common/shared.model';
import { Candidate } from '../../../shared/models/scheduling/candidate.model';

/* User defined enums/constants */
import { ComponentType } from '../../../shared/enums/scheduling.enum';
import { AgreementStates } from '../../../shared/constants/scheduling.constant';

import { ContentComponent } from '../../../shared/components/content/content.component';

@Component({
  selector: 'app-custom-agreement',
  templateUrl: './custom-agreement.component.html',
  styleUrls: ['./custom-agreement.component.scss'],
  providers: [DynamicComponentService]
})
export class CustomAgreementComponent implements OnInit {

  /* User defined private/public variables */
  public candidate: Candidate;
  private client: any;
  public consentOptions: string[] = [AgreementStates.Accept, AgreementStates.DoNotAgree];
  public content: ContentResponse;
  public isAgreementChecked: boolean;
  private program: any;

  /* Service subscriptions */
  client$: Subscription;
  program$: Subscription;
  resourceFileCulture$: Subscription;
  translateLanguage$: Subscription;
  public resourceFileCulture: string = '';

  @ViewChild(ContentComponent) contentInstance: ContentComponent;

  /* Constructor declaration with required injected services */
  constructor(
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {

    this.client$ = this.selectedExamDetailService.client.subscribe(
      data => {
        this.client = data;
      });

    this.program$ = this.selectedExamDetailService.program.subscribe(
      data => {
        this.program = data;
      });

    // update agreement on changing language from dropdown
    this.resourceFileCulture$ = this.selectedExamDetailService.resourceFileCulture.subscribe(
      resourceFileCulture => {
        this.resourceFileCulture = resourceFileCulture;
        this.getContent();
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.CustomAgreementComponent)) { return; }
    this.content = new ContentResponse();
    this.getContent();
  }

  ngAfterViewInit() {
    this.contentInstance.setFocusToContent();
  }

  /* Move to next page */
  submit(): void {
    this.selectedExamDetailService.isCustomAgreementChecked = this.isAgreementChecked;
    this.routingService.scheduleFwdNavigation(ComponentType.CustomAgreementComponent);
  }

  /* Move back a page. */
  goToPrevPage(): void {
    this.routingService.scheduleBwdNavigation(ComponentType.CustomAgreementComponent);
  }

  /* Call the agreement content from Xml resource file */
  getContent(): void {
    this.utilityService.getContent(this.selectedExamDetailService.customAgreementName, this.resourceFileCulture, this.program.code).subscribe(content => {
      this.content = content;
    });
  }

  /* On consent change */
  setConsentSelected(event: any): void {
    const value: boolean = (event === AgreementStates.Accept);

    this.isAgreementChecked = value;
    this.selectedExamDetailService.isCustomAgreementChecked = value;
  }
}
